import React from "react";
import PropTypes from "prop-types";

import StoryBody from "components/Library/StoryBody";
import SplitLayout from "components/Library/Layout/components/SplitLayout";
import CardWrapper from "cards/components/CardWrapper";
import Byline from "cards/components/Byline";

import styles from "./IntroOutroCard.css";

export default function IntroOutroCard({ story, authors }) {
  // We're passing in all of story instead of blocks for now because of this card's reliance
  //  on the <StoryBody/> component, which in turn relies heavily on receiving the entire story
  //  object in its props. <StoryBody/> will be refactored in the near future, so this is temporary.

  const hasBlocks = story.blocks && story.blocks.blocks.length > 0;
  const hasAuthors = authors && authors.length > 0;
  if (!hasBlocks && !hasAuthors) return null;

  return (
    <CardWrapper ariaRole="listitem">
      {hasAuthors && (
        <SplitLayout
          leftClassName={styles.byline}
          left={
            <>
              <span className={styles.authorPrefix}>{"By "}</span>
              <Byline authors={authors} />
            </>
          }
        />
      )}

      {hasBlocks && <StoryBody story={story} />}
    </CardWrapper>
  );
}

IntroOutroCard.propTypes = {
  story: PropTypes.shape({
    blocks: PropTypes.shape({
      blocks: PropTypes.array.isRequired,
    }).isRequired,
  }),
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      username: PropTypes.string.isRequired,
      display_name: PropTypes.string.isRequired,
    })
  ),
};
